import { call, fork, put, takeEvery, all } from 'redux-saga/effects';
import * as ga from '../../redux/actions/app';

import {
  GET_COLUMN_DATA,
  GET_INVESTIGATION_DATA,
  GET_STATUS_COUNT,
  getColumnData,
  getColumnDataSuccess,
  getInvestigationDataFail,
  getInvestigationDataSuccess,
  getStatusCount,
  getStatusCountSuccess
} from '../../redux/actions/tm/investigation';

import { getAMLSCommonUnifiedAlertCountByMetricName } from '../../redux/actions/common';
import {
  getInvestigationData,
  getInvestigationDataCounts
} from '../../services/tm/investigation';
import { UNIFIED_ALERT_METRICS } from '../../pages/constants/commonConstants';

function* getStatusCountWorker(payload) {
  try {
    yield put(ga.fetchRequest({ text: 'fetching...' }));
    const response = yield call(getStatusCount, payload);
    yield put(getStatusCountSuccess(response));

    yield put(ga.fetchSuccess());
  } catch (error) {
    yield put(ga.fetchFailed({ error: '' }));
  }
}

function* getColumnDataWorker(payload) {
  try {
    yield put(ga.fetchRequest({ text: 'fetching...' }));
    const response = yield call(getColumnData, payload);
    yield put(getColumnDataSuccess(response));

    yield put(ga.fetchSuccess());
  } catch (error) {
    yield put(ga.fetchFailed({ error: '' }));
  }
}

function* getInvestigationDataWorker(payload) {
  try {
    const {
      OPEN,
      CLOSED,
      UNDER_INVESTIGATION,
      ASSIGNED,
      PENDING_APPROVAL,
      ALERT_COUNT,
      ANOMALY_COUNT
    } = UNIFIED_ALERT_METRICS;
    yield put(ga.fetchRequest({ text: 'fetching...' }));
    const [
      list,
      open,
      closed,
      underInvestigation,
      assigned,
      pendingApproval,
      alertCount,
      anomalyCount
    ] = yield all([
      call(getInvestigationData, payload),
      call(getAMLSCommonUnifiedAlertCountByMetricName, {
        metricName: OPEN,
        data: payload
      }),
      call(getAMLSCommonUnifiedAlertCountByMetricName, {
        metricName: CLOSED,
        data: payload
      }),
      call(getAMLSCommonUnifiedAlertCountByMetricName, {
        metricName: UNDER_INVESTIGATION,
        data: payload
      }),
      call(getAMLSCommonUnifiedAlertCountByMetricName, {
        metricName: ASSIGNED,
        data: payload
      }),
      call(getAMLSCommonUnifiedAlertCountByMetricName, {
        metricName: PENDING_APPROVAL,
        data: payload
      }),
      call(getAMLSCommonUnifiedAlertCountByMetricName, {
        metricName: ALERT_COUNT,
        data: payload
      }),
      call(getAMLSCommonUnifiedAlertCountByMetricName, {
        metricName: ANOMALY_COUNT,
        data: payload
      })
    ]);

    const typeWiseCount = {
      all: alertCount + anomalyCount,
      alert: alertCount,
      anomlay: anomalyCount
    };
    const statusWiseCount = {
      open: open,
      closed: closed,
      underInvestigation: underInvestigation,
      assigned: assigned,
      pendingApproval: pendingApproval
    };

    const response = {
      list,
      typeWiseCount,
      statusWiseCount: {
        ...statusWiseCount,
        all:
          statusWiseCount?.open +
          statusWiseCount?.closed +
          statusWiseCount?.underInvestigation +
          statusWiseCount?.assigned +
          statusWiseCount?.pendingApproval
      }
    };

    yield put(getInvestigationDataSuccess(response));
    yield put(ga.fetchSuccess());
  } catch (error) {
    yield put(ga.fetchFailed({ error: '' }));
    yield put(getInvestigationDataFail({ error }));
  }
}

export function* watchGetStatusCount() {
  yield takeEvery(GET_STATUS_COUNT, function* ({ payload }) {
    yield fork(getStatusCountWorker, payload);
  });
}

export function* watchGetColumnData() {
  yield takeEvery(GET_COLUMN_DATA, function* ({ payload }) {
    yield fork(getColumnDataWorker, payload);
  });
}

export function* watchGetInvestigationData() {
  yield takeEvery(GET_INVESTIGATION_DATA, function* ({ payload }) {
    yield fork(getInvestigationDataWorker, payload);
  });
}
